import { useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router';
export const useTitle = (title: string, _gtmId: string) => {
    const intl = useIntl();
    const location = useLocation();

    const initialRender = useRef(import.meta.env.DEV);
    useEffect(() => {
        if (initialRender.current || document.title === title) {
            initialRender.current = false;
            return;
        }
        document.title = intl.formatMessage({ id: title });
    }, [title, location, intl]);
};
